/**
 * Horizontal hairline that spans the `max-w-6xl` content column rather than
 * the full viewport width, so it terminates exactly at the page's vertical
 * guide lines (see `MarketingShell`). The host `<section>` must be
 * `position: relative`.
 */
export function SectionTopDivider() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute top-0 left-1/2 z-0 h-px w-full max-w-6xl -translate-x-1/2 bg-border"
    />
  )
}
